import { Add } from "@mui/icons-material";
import { useState } from "react";
import { Button, List, SearchInput, TopToolbar, useTranslate } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { LocationTypeEnum } from "../generated/graphql";
import { useLocationFilterContext } from "../hooks/useLocationFilterContext";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { EmptyList } from "./EmptyList";
import { ListTitle } from "./ListTitle";
import LocationCreate from "./LocationCreate";
import { LocationDataGrid } from "./LocationDataGrid";

const LocationListActions = ({
  disabled,
  onCreateClick,
  isAllStandorte,
}: {
  disabled: boolean;
  onCreateClick: () => void;
  isAllStandorte: boolean;
}) => {
  const translate = useTranslate();
  const createLabel = isAllStandorte
    ? translate("emptyList.locationSites.createButton", { _: "Standort hinzufügen" })
    : translate("emptyList.location.createButton");
  return (
    <TopToolbar>
      <Button
        label={createLabel}
        variant="contained"
        disabled={disabled}
        onClick={onCreateClick}
        data-testid="create-button"
      >
        <Add />
      </Button>
    </TopToolbar>
  );
};

const LocationList = () => {
  const translate = useTranslate();
  const { organizationId: selectedOrganizationId } = useOrganizationContext();
  const { locationId: selectedLocationId } = useLocationFilterContext();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const isAllStandorte = !selectedLocationId;
  const emptyDescription = isAllStandorte
    ? translate("emptyList.locationSites.description", { _: "Sie haben noch keine Standorte hinzugefügt." })
    : translate("emptyList.location.description");
  const createButtonLabel = isAllStandorte
    ? translate("emptyList.locationSites.createButton", { _: "Standort hinzufügen" })
    : translate("emptyList.location.createButton");

  const handleCreateClick = () => {
    setIsCreateDialogOpen(true);
  };

  const handleCreateClose = () => {
    setIsCreateDialogOpen(false);
  };

  return (
    <>
      <List
        resource="Location"
        filters={[<SearchInput key="search" source="search" alwaysOn />]}
        actions={
          <LocationListActions
            disabled={!selectedOrganizationId}
            onCreateClick={handleCreateClick}
            isAllStandorte={isAllStandorte}
          />
        }
        filter={{
          organizationId: selectedOrganizationId,
          type: selectedLocationId ? undefined : [LocationTypeEnum.Site],
          partOfId: selectedLocationId,
        }}
        title={<ListTitle title="Standorte" />}
        perPage={ROWS_PER_PAGE}
        empty={
          <EmptyList
            image="/images/location.svg"
            description={emptyDescription}
            createButton={{ label: createButtonLabel, onClick: handleCreateClick, disabled: !selectedOrganizationId }}
          />
        }
      >
        <LocationDataGrid />
      </List>
      {isCreateDialogOpen && <LocationCreate open={isCreateDialogOpen} onClose={handleCreateClose} />}
    </>
  );
};

export default LocationList;
